import { Button, Table, Tag } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actionStoreQrTracking,
  filterSelector,
} from "../../../../../redux/slices/store-qr/tracking";
import { useApi } from "../../../../../hooks/http2";
import { displayTotal } from "../../../../../utils/helper";
import dayjs from "dayjs";
import { FaEye, FaQrcode } from "react-icons/fa";
import { Link } from "react-router-dom";

const TableBill = () => {
  const dispatch = useDispatch();
  const filter = useSelector(filterSelector);
  const { SET_FILTER } = actionStoreQrTracking;

  const bill = useApi(
    {
      url: "/store-qr/tracking",
      params: {
        ...filter,
        start_date: filter.start_date
          ? filter.start_date.format("YYYY-MM-DD")
          : null,
        end_date: filter.end_date ? filter.end_date.format("YYYY-MM-DD") : null,
        offset: (filter.page - 1) * filter.limit,
      },
      token: true,
    },
    [filter]
  );

  return (
    <Table
      bordered
      size="small"
      loading={bill.loading}
      dataSource={bill.fetch?.list || []}
      pagination={{
        size: "default",
        total: bill.fetch?.total || 0,
        pageSize: filter.limit,
        current: filter.page,
        showLessItems: true,
        showTotal: displayTotal,
        onChange: (page) => dispatch(SET_FILTER({ page })),
      }}
      rowKey={"document_no"}
    >
      <Table.Column
        key="no"
        title="เลขที่"
        dataIndex="document_no"
        render={(document_no, { ref_document_no }) => (
          <>
            <p className="mb-0">
              <small className="mr-2">ใบเสร็จ:</small>
              <span>{document_no}</span>
            </p>
            <p className="mb-0">
              <small className="mr-2">คำสั่งซื้อ/ใบจอง:</small>
              <small>
                <i>{ref_document_no || "-"}</i>
              </small>
            </p>
          </>
        )}
      />
      <Table.Column
        key="document_date"
        title="วันที่ใบเสร็จ"
        dataIndex="document_date"
        align="center"
        render={(document_date) => {
          return (
            <small>{dayjs(document_date).format("DD/MM/YYYY HH:mm")}</small>
          );
        }}
      />
      <Table.Column
        key="member"
        title="สมาชิก"
        dataIndex="partner_code"
        render={(partner_code, { partner_name }) => (
          <>
            <p className="mb-0">
              <small className="mr-2">รหัส:</small>
              <small>{partner_code}</small>
            </p>
            <p className="mb-0">
              <small className="mr-2">ชื่อ:</small>
              <small>{partner_name}</small>
            </p>
          </>
        )}
      />
      <Table.Column
        key="branch"
        title="สาขา"
        dataIndex="bill_location"
        render={(bill_location, { receipt_branch_name }) => (
          <>
            <p className="mb-0">
              <small className="mr-2">สาขาที่ทำรายการ:</small>
              <small>
                <i>{bill_location}</i>
              </small>
            </p>
            <p className="mb-0">
              <small className="mr-2">สาขาที่รับสินค้า:</small>
              <small>
                <i>{receipt_branch_name}</i>
              </small>
            </p>
          </>
        )}
      />
      <Table.Column
        key="req_receipt_type"
        title="การรับสินค้า"
        dataIndex="req_receipt_type"
        align="center"
        render={(req_receipt_type) => {
          return (
            <small>
              {req_receipt_type?.toLowerCase() === "branch"
                ? "รับที่สาขา"
                : "จัดส่ง"}
            </small>
          );
        }}
      />
      <Table.Column
        key="status"
        title="สถานะ"
        dataIndex="document_status"
        render={(document_status, { ship_status_text }) => {
          const is_cancel = document_status?.toLowerCase() === "cancel";

          return (
            <>
              <p className="mb-0">
                <small className="mr-2">ใบเสร็จ:</small>
                <span>
                  <Tag color={is_cancel ? "red" : "cyan"}>
                    {is_cancel ? "ยกเลิก" : "ปกติ"}
                  </Tag>
                </span>
              </p>
              <p className="mb-0">
                <small className="mr-2">รับสินค้า/จัดส่ง:</small>
                <small>
                  <i>{ship_status_text}</i>
                </small>
              </p>
            </>
          );
        }}
      />
      <Table.Column
        dataIndex="document_no"
        align="center"
        render={(document_no, { is_qr }) => (
          <Link to={`/store-qr/tracking/${document_no}`}>
            <Button type="primary" size="small" shape="circle-outline">
              {is_qr === 1 ? <FaQrcode /> : <FaEye />}
            </Button>
          </Link>
        )}
      />
    </Table>
  );
};

export default TableBill;
